module.exports = __webpack_public_path__ + "img/authentication-image.1118361d.svg";